module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/62bf6bfa8f606e548903e05a9c00c930.png";